import React from 'react'
import Logo from "Assets/images/KCS-LogoOnboard.png"
import { Col, Row } from 'react-bootstrap'

function OnboardHeader() {
  return (
    <Row>
      <Col className='col-9 mx-auto'>
        <img src={Logo} alt="" />
      </Col>
    </Row>
  )
}

export default OnboardHeader
